import { FilterValue } from "../Filters/FilterValue";
import { SwayyStatusTone } from "../SwayyOrder/SwayyOrderFilters";
import { SwayyShipmentStatus } from "./SwayyShipment";

export const SWAYY_SHIPMENT_STATUS_ALL_TAB = "all";
export const SWAYY_SHIPMENT_DEFAULT_STATUS_TAB = "created";

export const SWAYY_SHIPMENT_STATUS_OPTIONS: FilterValue[] = [
  { id: "created", value: "Created" },
  { id: "picked_up", value: "Picked Up" },
  { id: "in_transit", value: "In Transit" },
  { id: "out_for_delivery", value: "Out for Delivery" },
  { id: "delivered", value: "Delivered" },
  { id: "failed_delivery", value: "Failed Delivery" },
  { id: "rto_initiated", value: "RTO Initiated" },
  { id: "rto_delivered", value: "RTO Delivered" },
];

/** Listing tabs: All first, then every shipment status. */
export const SWAYY_SHIPMENT_STATUS_TABS: FilterValue[] = [
  { id: SWAYY_SHIPMENT_STATUS_ALL_TAB, value: "All" },
  ...SWAYY_SHIPMENT_STATUS_OPTIONS,
];

export const SWAYY_SHIPPABLE_ORDER_STATUSES = new Set([
  "confirmed",
  "processing",
  "partially_shipped",
]);


export const SWAYY_SHIPMENT_TRANSITIONS: Record<string, SwayyShipmentStatus[]> =
  {
    created: ["picked_up"],
    picked_up: ["in_transit"],
    in_transit: ["out_for_delivery", "failed_delivery", "rto_initiated"],
    out_for_delivery: ["delivered", "failed_delivery"],
    failed_delivery: ["out_for_delivery", "rto_initiated"],
    rto_initiated: ["rto_delivered"],
    delivered: [],
    rto_delivered: [],
  };

export const getSwayyShipmentStatusLabel = (status: string): string =>
  SWAYY_SHIPMENT_STATUS_OPTIONS.find((option) => option.id === status)?.value ??
  status.replace(/_/g, " ");

export const getSwayyShipmentNextStatuses = (
  status: string,
): FilterValue[] => {
  const next = SWAYY_SHIPMENT_TRANSITIONS[status] ?? [];
  return next.map((id) => ({
    id,
    value: getSwayyShipmentStatusLabel(id),
  }));
};

export const canEditSwayyShipmentTracking = (status: string): boolean =>
  status === "created" || status === "picked_up";

export const canDeleteSwayyShipment = (status: string): boolean =>
  status === "created";

export const getSwayyShipmentStatusTone = (status: string): SwayyStatusTone => {
  const value = (status || "").toLowerCase();
  if (["delivered"].includes(value)) return "success";
  if (["picked_up", "in_transit", "out_for_delivery"].includes(value)) {
    return "pine";
  }
  if (["failed_delivery", "rto_initiated", "rto_delivered"].includes(value)) {
    return "danger";
  }
  if (["created"].includes(value)) return "warning";
  return "muted";
};
